import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import WhyPhilippinesStrip from './components/WhyPhilippinesStrip';
import ServicesPreview from './components/ServicesPreview';
import FeaturedProjects from './components/FeaturedProjects';
import OurExpertise from './components/our-expertise';
import WhatWeOffer from './components/what-we-offer';
import FAQ from './components/FAQ';
// import ClientLogos from './components/ClientLogos';
import NewsletterSignup from './components/NewsletterSignup';
import Footer from '../../components/ui/Footer';

const Homepage = () => {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Cleanup
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  const pageVariants = {
    initial: { opacity: 0 },
    animate: { 
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: [0.4, 0, 0.2, 1]
      }
    },
    exit: { 
      opacity: 0,
      transition: {
        duration: 0.3
      }
    }
  };

  return (
    <motion.div
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className="min-h-screen bg-background"
    >
      {/* Header */}
      <Header />
      {/* Main Content */}
      <main className="relative pt-16">

        {/* Hero Section */}
        <HeroSection />

        {/* Why Philippines */}
        <WhyPhilippinesStrip />

        {/* WhatWeOffer */}
        <WhatWeOffer />

        {/* Featured Projects */}
        <FeaturedProjects />

        {/* Services Preview */}
        <ServicesPreview />

        {/* Our Expertise */}
        <OurExpertise />

        {/* FAQ */}
        <FAQ />

        {/* Newsletter Signup */}
        {/* <NewsletterSignup /> */}
      </main>
      {/* Footer */}
      <Footer />
      {/* Scroll Progress Indicator */}
      <motion.div
        className="fixed top-0 left-0 right-0 h-1 bg-gradient-to-r from-primary to-accent z-50 origin-left"
        style={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: false }}
        transition={{ duration: 0.3 }}
      />
    </motion.div>
  );
};

export default Homepage;